var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content statisticsOrders" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.search.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("date-picker", {
                    attrs: {
                      type: "date",
                      range: "",
                      "value-type": "format",
                      format: "DD.MM.YYYY",
                      shortcuts: _vm.shortcuts,
                      placeholder: "Выберите дату",
                    },
                    on: { change: _vm.handleChangeDatePicker },
                    model: {
                      value: _vm.filter.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "date", $$v)
                      },
                      expression: "filter.date",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-sm btn-success",
                      "data-style": "zoom-in",
                      type: "submit",
                      loading: _vm.loading,
                    },
                  },
                  [_vm._v("Поиск\n          ")]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.showResultBlock
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: { loading: _vm.loading, color: _vm.loadingColor },
              }),
              _vm._v(" "),
              _vm.records
                ? _c(
                    "div",
                    [_c("StatisticChart", { attrs: { records: _vm.records } })],
                    1
                  )
                : _c("div", [
                    !_vm.loading
                      ? _c("h4", [_vm._v("Заявок не найдено")])
                      : _vm._e(),
                  ]),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Фильтр")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-4" }, [
      _c("select", { staticClass: "form-control" }, [
        _c("option", { attrs: { value: "-1", selected: "" } }, [
          _vm._v("Все заявки"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }